<div class="loader-for-placeholder">
    <div class="loader-for-placeholder__inner">
        <div class="loader-for-placeholder__content">
            <ng-content></ng-content>
        </div>
    </div>
</div>